



































// This component is typically used as a dynamic component inside ModalWrapperComponent
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TokenUser } from '../TokenUser';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import * as utils_tracker from '../utils_tracker';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';
import ModalWrapperComponent from '@/components/ModalWrapperComponent.vue';             // @ is an alias to /src
import GoogleLoginButtonComponent from '@/components/GoogleLoginButtonComponent.vue';                       // @ is an alias to /src
import DapperLoginButtonComponent from '@/components/DapperLoginButtonComponent.vue';                       // @ is an alias to /src

@Component({
  name: 'LoginFormComponent',
  components: { ModalWrapperComponent, GoogleLoginButtonComponent, DapperLoginButtonComponent }
})
export default class LoginFormComponent extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template
  public usernameOrEmail: string = null;
  public password: string = null;

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }

  public onCancel() {
    this.$emit('close', false)
    this.clearFields()
  }
  public clearFields() {
    this.usernameOrEmail = null;
    this.password = null;
  }
  public async onShow(dynamicProps: any) {
    this.clearFields()
  }
  public forgotPassword() {
    this.$nextTick(() => {
      (this.$refs.ResetPasswordFormComponent as ModalWrapperComponent).show('Reset Password', 'md', { usernameOrEmail: this.usernameOrEmail })
    })
  }
  public async onOK() {

    // tidy up form fields
    if (this.usernameOrEmail) this.usernameOrEmail = this.usernameOrEmail.trim()
    if (this.password) this.password = this.password.trim()

    // validate form fields
    let abort: boolean = false
    if (!this.usernameOrEmail || this.usernameOrEmail.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter an email address')
    }
    if (!this.password || this.password.length === 0) {
      abort = true
      utils.toast(this, 'Missing field', 'Please enter a password')
    }

    if (abort) return

    // make POST call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = `${this.url}`;
      const response: any = await utils.makePostCall(url, { usernameOrEmail: this.usernameOrEmail, password: this.password } );
      if (!response || !response.data) throw(new Error('LoginFormComponent.onOK() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });

        if (response.data.error === 'User not found') {
          utils_tracker.track('Email Wrong', { usernameOrEmail: this.usernameOrEmail })
        }

        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.user && response.data.sessionId) {
        // success
        this.$store.commit('setLoading', { loading: false });
        this.$emit('close', true)

        // clear out in case they do another
        this.clearFields()

        const user: TokenUser = new TokenUser(response.data.user)
        user.email = response.data.email     // this got stripped away to make safe for client
        utils_auth.saveAuthStuffToStoreAndLocalStorage(user, response.data.sessionId)
        globalUC.add(user)      // might as well give cache the very latest one
        // utils.toast(this, 'Success', `Login successful for ${user.username || user.email}`)

        utils_tracker.alias(user)  // tie the previously anon user to this newly id'd user

        utils_tracker.track('User LoggedIn', { email: user.email })

        // in case old version
        if (utils.isClientOld()) {
          console.log("Calling this.$router.go(0)");
          this.$router.go(0);
          this.$store.commit('setLoading', { loading: false });
          return;
        }

        // go to subsequent page
        try {
          const whereToGo: RawLocation = utils_auth.getLocationAfterLogin()
          if (whereToGo) {
            await this.$router.push(whereToGo);
            utils_auth.setLocationAfterLogin(null)
          } else {
            await this.$router.push({ name: 'home' })
          }
        } catch (Error) {}

      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not login')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }

  }

  // private, non-reactive member variables
  private url: string = utils.getURLprefix() + '/api/auth/login';

  // private functions not available directly to HTML template
  private async mounted() { 
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    utils_tracker.track('User ClickedLogin', {})
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

}
